// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1EJyC","author":"Table_author__2qwfX","authorImage":"Table_authorImage__1mkwX","unreadRow":"Table_unreadRow__1lGhB"};